import { API_URL } from '../constants/config';

export function documentDownloadUrl(filename, { download = false } = {}) {
  if (!filename) return undefined;
  const url = `${API_URL}/documents/download/${encodeURIComponent(filename)}`;
  return download ? `${url}?download=1` : url;
}

export async function openDocumentInBrowser(filename) {
  const url = documentDownloadUrl(filename);
  if (!url) return;

  const preview = window.open('about:blank', '_blank');

  try {
    const response = await fetch(url);
    if (!response.ok) {
      if (preview) preview.location = url;
      else window.location.href = url;
      return;
    }

    const blob = await response.blob();
    const pdfBlob = blob.type === 'application/pdf'
      ? blob
      : new Blob([blob], { type: 'application/pdf' });
    const objectUrl = URL.createObjectURL(pdfBlob);

    if (preview) {
      preview.location = objectUrl;
    } else {
      window.location.href = objectUrl;
    }
  } catch (error) {
    if (preview) preview.location = url;
    else window.open(url, '_blank', 'noopener,noreferrer');
  }
}
